<template>
  <el-dialog
    @open="onOpen"
    title="Selecionar Condomínio"
    :visible.sync="visibility"
    :before-close="fechar"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    width="60%"
  >
    <el-row>
      <el-form size="mini" label-position="top">
        <el-form-item label="Nome">
          <el-input v-model="condominioPesquisa.nome"></el-input>
        </el-form-item>
      </el-form>
    </el-row>

    <el-row type="flex" justify="end">
      <h4 style="color: #606266; margin: 10px 0px">{{ this.labelQuantidade }}</h4>
    </el-row>

    <el-row>
      <el-table
        :data="this.condominiosFiltrados"
        highlight-current-row
        @current-change="selecaoLinhaHandler"
        @row-dblclick="cliqueDuploLinhaHandler"
        stripe
        height="200"
        empty-text="Nenhum Condomínio encontrado"
      >
        <el-table-column
          prop="nome"
          label="Nome"
          sortable
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span style="font-weight: bold">{{ scope.row.nome }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <span slot="footer" class="dialog-footer">
      <el-button
        @click="gravar"
        type="success"
        size="small"
        round
        class="btn-box-shadow"
      >
        Selecionar
      </el-button>

      <el-button
        @click="fechar"
        type="danger"
        size="small"
        round
        class="btn-box-shadow"
      >
        Fechar
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  props: {
    visibility: Boolean
  },
  data() {
    return {
      condominio: undefined,
      condominioPesquisa: { nome: undefined }
    }
  },
  computed: {
    ...mapState('administradorasStore', {
      administradora(state) { return state.administradoraSelecionada },
      condominios(state) { return state.listaCondominios }
    }),
    condominiosFiltrados() {
      return this.condominios.filter((condominio) => {
        return !this.condominioPesquisa.nome || condominio.nome.toLowerCase().includes(this.condominioPesquisa.nome.toLowerCase())
      });
    },
    labelQuantidade() {
      switch(this.condominiosFiltrados.length) {
        case 0:
          return "Nenhum Condomínio encontrado";
        case 1:
          return "1 Condomínio encontrado";
        default:
          return `${this.condominiosFiltrados.length} Condomínios encontrados`;
      }
    } 
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('administradorasStore', [
      'adicionarCondominio',
      'listarCondominios'
    ]),
    onOpen() {
      this.reset();
      
      this.showLoading();
      this.listarCondominios().then(() => {
        this.hideLoading();
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    reset() {
      this.condominio = undefined;
      this.condominioPesquisa = { nome: undefined };
    },
    fechar() {
      this.$emit('close');
    },
    gravar() {
      if(!this.condominio) {
        this.$message.warning("Selecione um Condomínio na tabela");
        return;
      }
      this.showLoading();
      this.condominio.administradora.id = this.administradora.id;
      this.adicionarCondominio(this.condominio)
        .then((resultado) => {
          this.hideLoading();
          switch(resultado.status) {
            case "ERRO":
              this.$message.error(resultado.mensagem);
              break;
            case "SUCESSO":
              this.$message.success(resultado.mensagem);   
          }
        }).catch(() => {
          this.hideLoading();
          this.$message.error('Não foi possível conectar-se ao servidor');
        });
      this.fechar();
    },
    selecaoLinhaHandler(row) {
      this.condominio = row;
    },
    cliqueDuploLinhaHandler() {
      this.gravar();
    }
  }
}
</script>